import { env } from "./config";
import UseStoreHandler from "./handlers/UseStoreHandler";
import { translate } from "./translate";

export function showToast(toast, message, severity = 'success', seconds = 5000, title = ''){
    const storageStore = UseStoreHandler.getStoreContext();
    const lastMessageData = storageStore.get('toast_last_message');

    if (lastMessageData) {
        const { message: lastMessage, date: lastDateString } = lastMessageData;
        
        const lastDate = new Date(lastDateString);
        const now = new Date();
        
        const timeDifference = now.getTime() - lastDate.getTime();

        if (lastMessage === message && timeDifference < 5000) {
            return;
        }
    }

    storageStore.save('toast_last_message', {
        message: message,
        date: new Date()
    })

    if (!env('APP_PRODUCTION')) {
        console.log('[showToast] chamado de:', new Error().stack.split('\n')[2]);
        console.log('[showToast]', { message, severity });
    }

    if (typeof message == 'object' && message.message != undefined) {
        message = message.message;
    }

    message = translate(message);

    const severities = ['success','info','warn','error','secondary','contrast'];
    
    if(!severities.includes(severity))
        severity = 'success';

    if(title == '')
        title = env('APP_NAME');

    if(severity == 'error')
        message += '!';

    toast.add({ severity: severity, summary: title, detail: message, life: seconds });

    let tries = 0;
    let toastEl = null;

    while(toastEl == null) {

        toastEl = document.querySelector('.p-toast');
        if (tries > 5) {
            break;
        }

        tries++;
    }

    if (!toastEl) {
        return;
    }

    toastEl.style.left = 'unset';
    let screenWidth = window.innerWidth;
    if(screenWidth < 450 && (toastEl != null && toastEl != undefined)){
      let percent = screenWidth / 100;
      let margin = percent * 5;
      toastEl.style.width = (percent * 90) + 'px';
      toastEl.style.right = margin + 'px';
      toastEl.style.left  = margin + 'px';
    }
}